import React from "react";
import dateFormat from "dateformat";
import { useAppDispatch } from "@redux/store";
import { setDate } from "@redux/rent/slice";
import { setRentDateToStorage } from "@utils/index";
import { getPrevDate, getNextDate, formatCurrentDate, isPrevDateDisabled } from "@utils/date/racketRentDate";
import styles from "./DateNavigation.module.scss";
import arrowLeftIcon from "@assets/icons/arrowCalendarLeft.svg";
import arrowRightIcon from "@assets/icons/arrowCalendarRight.svg";

interface DateNavigationProps {
  date: string;
}

export const DateNavigation: React.FC<DateNavigationProps> = ({ date }) => {
  const dispatch = useAppDispatch();

  const currentDate = formatCurrentDate(date);
  const disablePrevButton = isPrevDateDisabled(date);

  console.log(date);

  const handlePrevDate = () => {
    const prevDate = dateFormat(getPrevDate(date), "isoDate");
    setRentDateToStorage(prevDate);
    dispatch(setDate(prevDate));
  };

  const handleNextDate = () => {
    const nextDate = dateFormat(getNextDate(date), "isoDate");
    setRentDateToStorage(nextDate);
    dispatch(setDate(nextDate));
  };

  return (
    <div className={styles.navigate}>
      <button
        className={styles.navigate_button}
        disabled={disablePrevButton}
        onClick={handlePrevDate}
      >
        <img src={arrowLeftIcon} alt="prev day" />
      </button>
      <div className={styles.navigate_currentDay}>
        <span className={styles.navigate_currentDay_name}>
          {currentDate.monthName} {currentDate.yearName}
        </span>
      </div>
      <button
        className={styles.navigate_button}
        onClick={handleNextDate}
      >
        <img src={arrowRightIcon} alt="next day" />
      </button>
    </div>
  );
};

